import {Component, ContentChild, Input, TemplateRef} from '@angular/core';
import {Ticket, TicketPriorityId, ticketStatusColourMapByTicketType, TicketStatusId} from '@shared/services';

@Component({
  selector: 'app-ticket-status',
  templateUrl: './ticket-status.component.html',
  styleUrls: ['./ticket-status.component.scss'],
  standalone: false
})
export class TicketStatusComponent {

  @Input() ticket: Ticket;
  @Input() fontSize: string;
  @Input() hidePriority = false;
  @Input() contentPosition: 'inside' | 'outside' = 'outside';
  @ContentChild('contentTemplate') contentTemplate: TemplateRef<any> | null = null;

  private readonly DEFAULT_COLOR = 'secondary';

  TicketStatusId = TicketStatusId;

  isHighPriority(ticket: Ticket): boolean {
    return ticket.priority && TicketPriorityId.isHighPriority(ticket.priority.priority_id);
  }

  get displayText(): string {
    return this.ticket?.status?.display_text;
  }

  get badgeColourStyle(): string {
    return 'text-bg-' + (ticketStatusColourMapByTicketType.get(this.ticket?.type)?.get(this.ticket?.status?.status_id) || this.DEFAULT_COLOR);
  }
}
